// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-number {\n  color: #ffffff;\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  border-radius: 50%;\n  background-color: var(--v-woocommerce-base);\n  text-align: center;\n  margin-top: 2px;\n}\n.circle-number--small {\n  height: 16px;\n  width: 16px;\n  min-width: 16px;\n  font-size: 12px;\n  line-height: 16px;\n}\n.icon-chevron {\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);\n}", ""]);
// Exports
module.exports = exports;
